import { getMessagingInstance } from "../firebase";
import { getToken } from "firebase/messaging";
import { doc, setDoc, arrayUnion } from "firebase/firestore";
import { db } from "../firebase";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  // Pass this project's Firebase config to the SW via the registration URL —
  // the SW file is static (public/) and can't read build-time env vars, and a
  // hardcoded config would pin every environment to one project.
  const params = new URLSearchParams({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MSG_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  });
  const reg = await navigator.serviceWorker.register(`/firebase-messaging-sw.js?${params}`);
  if (reg.installing) {
    await new Promise((resolve) => {
      reg.installing.addEventListener("statechange", (e) => {
        if (e.target.state === "activated") resolve();
      });
    });
  }
  return reg;
}

async function saveToken(token) {
  await setDoc(
    doc(db, "meta", "adminDevice"),
    { fcmTokens: arrayUnion(token), updatedAt: new Date().toISOString() },
    { merge: true }
  );
  console.log("Admin FCM token saved:", token.substring(0, 25));
}

// Ask permission (if needed) and return a fresh FCM token, or null.
async function obtainToken() {
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    console.warn("Notification permission denied");
    return null;
  }
  const swReg = await registerServiceWorker();
  const messaging = await getMessagingInstance();
  if (!messaging) {
    console.warn("FCM not supported on this browser");
    return null;
  }
  return getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: swReg });
}

export async function registerAdminFcmToken() {
  try {
    const token = await obtainToken();
    if (token) await saveToken(token);
    return token;
  } catch (err) {
    console.error("registerAdminFcmToken error:", err);
    return null;
  }
}

// User device token — lets the backend push "TurantX replied" (TurantChat)
// to the user. Rules allow the owner to touch ONLY fcmTokens/fcmUpdatedAt
// on their users/{phone} doc.
export async function registerUserFcmToken(phone) {
  if (!phone) return null;
  try {
    const token = await obtainToken();
    if (!token) return null;
    await setDoc(
      doc(db, "users", phone),
      { fcmTokens: arrayUnion(token), fcmUpdatedAt: new Date().toISOString() },
      { merge: true }
    );
    return token;
  } catch (err) {
    console.error("registerUserFcmToken error:", err);
    return null;
  }
}
